/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { ContentControlSchema } from '@ecsper/speciality-contract';

/**
 * The Statement of Truth tag prefix. Each instance has a UUID suffix
 * (e.g., 'ecsper:sot:abc-123') so multiple reports do not collide
 * when joined documents are produced.
 */
export const SOT_TAG_PREFIX = 'ecsper:sot:';

/**
 * The CPR Part 35 declaration is a singleton per document (no UUID suffix).
 * Per CPR Part 35.3, every report includes the same declaration text.
 */
export const DECLARATION_TAG = 'ecsper:declaration';

export const STATEMENT_OF_TRUTH_TEXT = [
  'I confirm that I have made clear which facts and matters referred to in this report',
  'are within my own knowledge and which are not. Those that are within my own',
  'knowledge I confirm to be true. The opinions I have expressed represent my true',
  'and complete professional opinions on the matters to which they refer.',
].join(' ');

export const CPR_PART_35_DECLARATION_TEXT = [
  'I understand that my duty is to help the court to achieve the overriding objective',
  'by giving independent assistance by way of objective, unbiased opinion on matters',
  'within my expertise, both in preparing reports and giving oral evidence.',
  'I understand that this duty overrides any obligation to the party by whom I am',
  'engaged or the person who has paid or is liable to pay me.',
  'I confirm that I have complied and will continue to comply with my duty.',
].join(' ');

export const expertWitnessContentControlSchemas: readonly ContentControlSchema[] = [
  {
    tag: SOT_TAG_PREFIX,
    title: { 'en-GB': 'Statement of Truth' },
    required: true,
    defaultContent: STATEMENT_OF_TRUTH_TEXT,
    validationRuleId: 'sot-required',
  },
  {
    tag: DECLARATION_TAG,
    title: { 'en-GB': 'CPR Part 35 Declaration' },
    required: true,
    defaultContent: CPR_PART_35_DECLARATION_TEXT,
    validationRuleId: 'declaration-required',
  },
] as const;
